/**
 * @fileoverview gRPC-Web generated client stub for dowtex.tournaments
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v7.36.2
// source: tournament.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.dowtex = {};
proto.dowtex.tournaments = require('./tournament_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dowtex.tournaments.TournamentsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dowtex.tournaments.TournamentsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dowtex.tournaments.CreateRequest,
 *   !proto.dowtex.tournaments.TournamentView>}
 */
const methodDescriptor_Tournaments_Create = new grpc.web.MethodDescriptor(
  '/dowtex.tournaments.Tournaments/Create',
  grpc.web.MethodType.UNARY,
  proto.dowtex.tournaments.CreateRequest,
  proto.dowtex.tournaments.TournamentView,
  /**
   * @param {!proto.dowtex.tournaments.CreateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dowtex.tournaments.TournamentView.deserializeBinary
);


/**
 * @param {!proto.dowtex.tournaments.CreateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dowtex.tournaments.TournamentView)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dowtex.tournaments.TournamentView>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dowtex.tournaments.TournamentsClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/Create',
      request,
      metadata || {},
      methodDescriptor_Tournaments_Create,
      callback);
};


/**
 * @param {!proto.dowtex.tournaments.CreateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dowtex.tournaments.TournamentView>}
 *     Promise that resolves to the response
 */
proto.dowtex.tournaments.TournamentsPromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/Create',
      request,
      metadata || {},
      methodDescriptor_Tournaments_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dowtex.tournaments.GetRequest,
 *   !proto.dowtex.tournaments.TournamentView>}
 */
const methodDescriptor_Tournaments_Get = new grpc.web.MethodDescriptor(
  '/dowtex.tournaments.Tournaments/Get',
  grpc.web.MethodType.UNARY,
  proto.dowtex.tournaments.GetRequest,
  proto.dowtex.tournaments.TournamentView,
  /**
   * @param {!proto.dowtex.tournaments.GetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dowtex.tournaments.TournamentView.deserializeBinary
);


/**
 * @param {!proto.dowtex.tournaments.GetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dowtex.tournaments.TournamentView)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dowtex.tournaments.TournamentView>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dowtex.tournaments.TournamentsClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/Get',
      request,
      metadata || {},
      methodDescriptor_Tournaments_Get,
      callback);
};


/**
 * @param {!proto.dowtex.tournaments.GetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dowtex.tournaments.TournamentView>}
 *     Promise that resolves to the response
 */
proto.dowtex.tournaments.TournamentsPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/Get',
      request,
      metadata || {},
      methodDescriptor_Tournaments_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dowtex.tournaments.ListRequest,
 *   !proto.dowtex.tournaments.TournamentSummaries>}
 */
const methodDescriptor_Tournaments_List = new grpc.web.MethodDescriptor(
  '/dowtex.tournaments.Tournaments/List',
  grpc.web.MethodType.UNARY,
  proto.dowtex.tournaments.ListRequest,
  proto.dowtex.tournaments.TournamentSummaries,
  /**
   * @param {!proto.dowtex.tournaments.ListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dowtex.tournaments.TournamentSummaries.deserializeBinary
);


/**
 * @param {!proto.dowtex.tournaments.ListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dowtex.tournaments.TournamentSummaries)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dowtex.tournaments.TournamentSummaries>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dowtex.tournaments.TournamentsClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/List',
      request,
      metadata || {},
      methodDescriptor_Tournaments_List,
      callback);
};


/**
 * @param {!proto.dowtex.tournaments.ListRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dowtex.tournaments.TournamentSummaries>}
 *     Promise that resolves to the response
 */
proto.dowtex.tournaments.TournamentsPromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/List',
      request,
      metadata || {},
      methodDescriptor_Tournaments_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dowtex.tournaments.UpdateSettingsRequest,
 *   !proto.dowtex.tournaments.TournamentView>}
 */
const methodDescriptor_Tournaments_UpdateSettings = new grpc.web.MethodDescriptor(
  '/dowtex.tournaments.Tournaments/UpdateSettings',
  grpc.web.MethodType.UNARY,
  proto.dowtex.tournaments.UpdateSettingsRequest,
  proto.dowtex.tournaments.TournamentView,
  /**
   * @param {!proto.dowtex.tournaments.UpdateSettingsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dowtex.tournaments.TournamentView.deserializeBinary
);


/**
 * @param {!proto.dowtex.tournaments.UpdateSettingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dowtex.tournaments.TournamentView)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dowtex.tournaments.TournamentView>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dowtex.tournaments.TournamentsClient.prototype.updateSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/UpdateSettings',
      request,
      metadata || {},
      methodDescriptor_Tournaments_UpdateSettings,
      callback);
};


/**
 * @param {!proto.dowtex.tournaments.UpdateSettingsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dowtex.tournaments.TournamentView>}
 *     Promise that resolves to the response
 */
proto.dowtex.tournaments.TournamentsPromiseClient.prototype.updateSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/UpdateSettings',
      request,
      metadata || {},
      methodDescriptor_Tournaments_UpdateSettings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dowtex.tournaments.ReportResultRequest,
 *   !proto.dowtex.tournaments.TournamentView>}
 */
const methodDescriptor_Tournaments_ReportResult = new grpc.web.MethodDescriptor(
  '/dowtex.tournaments.Tournaments/ReportResult',
  grpc.web.MethodType.UNARY,
  proto.dowtex.tournaments.ReportResultRequest,
  proto.dowtex.tournaments.TournamentView,
  /**
   * @param {!proto.dowtex.tournaments.ReportResultRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dowtex.tournaments.TournamentView.deserializeBinary
);


/**
 * @param {!proto.dowtex.tournaments.ReportResultRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dowtex.tournaments.TournamentView)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dowtex.tournaments.TournamentView>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dowtex.tournaments.TournamentsClient.prototype.reportResult =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/ReportResult',
      request,
      metadata || {},
      methodDescriptor_Tournaments_ReportResult,
      callback);
};


/**
 * @param {!proto.dowtex.tournaments.ReportResultRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dowtex.tournaments.TournamentView>}
 *     Promise that resolves to the response
 */
proto.dowtex.tournaments.TournamentsPromiseClient.prototype.reportResult =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/ReportResult',
      request,
      metadata || {},
      methodDescriptor_Tournaments_ReportResult);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dowtex.tournaments.ReportResultRequest,
 *   !proto.dowtex.tournaments.TournamentView>}
 */
const methodDescriptor_Tournaments_CorrectResult = new grpc.web.MethodDescriptor(
  '/dowtex.tournaments.Tournaments/CorrectResult',
  grpc.web.MethodType.UNARY,
  proto.dowtex.tournaments.ReportResultRequest,
  proto.dowtex.tournaments.TournamentView,
  /**
   * @param {!proto.dowtex.tournaments.ReportResultRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dowtex.tournaments.TournamentView.deserializeBinary
);


/**
 * @param {!proto.dowtex.tournaments.ReportResultRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dowtex.tournaments.TournamentView)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dowtex.tournaments.TournamentView>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dowtex.tournaments.TournamentsClient.prototype.correctResult =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/CorrectResult',
      request,
      metadata || {},
      methodDescriptor_Tournaments_CorrectResult,
      callback);
};


/**
 * @param {!proto.dowtex.tournaments.ReportResultRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dowtex.tournaments.TournamentView>}
 *     Promise that resolves to the response
 */
proto.dowtex.tournaments.TournamentsPromiseClient.prototype.correctResult =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/CorrectResult',
      request,
      metadata || {},
      methodDescriptor_Tournaments_CorrectResult);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dowtex.tournaments.EntrantRequest,
 *   !proto.dowtex.tournaments.TournamentView>}
 */
const methodDescriptor_Tournaments_Withdraw = new grpc.web.MethodDescriptor(
  '/dowtex.tournaments.Tournaments/Withdraw',
  grpc.web.MethodType.UNARY,
  proto.dowtex.tournaments.EntrantRequest,
  proto.dowtex.tournaments.TournamentView,
  /**
   * @param {!proto.dowtex.tournaments.EntrantRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dowtex.tournaments.TournamentView.deserializeBinary
);


/**
 * @param {!proto.dowtex.tournaments.EntrantRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dowtex.tournaments.TournamentView)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dowtex.tournaments.TournamentView>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dowtex.tournaments.TournamentsClient.prototype.withdraw =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/Withdraw',
      request,
      metadata || {},
      methodDescriptor_Tournaments_Withdraw,
      callback);
};


/**
 * @param {!proto.dowtex.tournaments.EntrantRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dowtex.tournaments.TournamentView>}
 *     Promise that resolves to the response
 */
proto.dowtex.tournaments.TournamentsPromiseClient.prototype.withdraw =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/Withdraw',
      request,
      metadata || {},
      methodDescriptor_Tournaments_Withdraw);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dowtex.tournaments.EntrantRequest,
 *   !proto.dowtex.tournaments.TournamentView>}
 */
const methodDescriptor_Tournaments_Reinstate = new grpc.web.MethodDescriptor(
  '/dowtex.tournaments.Tournaments/Reinstate',
  grpc.web.MethodType.UNARY,
  proto.dowtex.tournaments.EntrantRequest,
  proto.dowtex.tournaments.TournamentView,
  /**
   * @param {!proto.dowtex.tournaments.EntrantRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dowtex.tournaments.TournamentView.deserializeBinary
);


/**
 * @param {!proto.dowtex.tournaments.EntrantRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dowtex.tournaments.TournamentView)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dowtex.tournaments.TournamentView>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dowtex.tournaments.TournamentsClient.prototype.reinstate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/Reinstate',
      request,
      metadata || {},
      methodDescriptor_Tournaments_Reinstate,
      callback);
};


/**
 * @param {!proto.dowtex.tournaments.EntrantRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dowtex.tournaments.TournamentView>}
 *     Promise that resolves to the response
 */
proto.dowtex.tournaments.TournamentsPromiseClient.prototype.reinstate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/Reinstate',
      request,
      metadata || {},
      methodDescriptor_Tournaments_Reinstate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dowtex.tournaments.AdvanceRequest,
 *   !proto.dowtex.tournaments.TournamentView>}
 */
const methodDescriptor_Tournaments_Advance = new grpc.web.MethodDescriptor(
  '/dowtex.tournaments.Tournaments/Advance',
  grpc.web.MethodType.UNARY,
  proto.dowtex.tournaments.AdvanceRequest,
  proto.dowtex.tournaments.TournamentView,
  /**
   * @param {!proto.dowtex.tournaments.AdvanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dowtex.tournaments.TournamentView.deserializeBinary
);


/**
 * @param {!proto.dowtex.tournaments.AdvanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dowtex.tournaments.TournamentView)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dowtex.tournaments.TournamentView>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dowtex.tournaments.TournamentsClient.prototype.advance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/Advance',
      request,
      metadata || {},
      methodDescriptor_Tournaments_Advance,
      callback);
};


/**
 * @param {!proto.dowtex.tournaments.AdvanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dowtex.tournaments.TournamentView>}
 *     Promise that resolves to the response
 */
proto.dowtex.tournaments.TournamentsPromiseClient.prototype.advance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/Advance',
      request,
      metadata || {},
      methodDescriptor_Tournaments_Advance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dowtex.tournaments.ShareTokenRequest,
 *   !proto.dowtex.tournaments.TournamentView>}
 */
const methodDescriptor_Tournaments_SetShareToken = new grpc.web.MethodDescriptor(
  '/dowtex.tournaments.Tournaments/SetShareToken',
  grpc.web.MethodType.UNARY,
  proto.dowtex.tournaments.ShareTokenRequest,
  proto.dowtex.tournaments.TournamentView,
  /**
   * @param {!proto.dowtex.tournaments.ShareTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dowtex.tournaments.TournamentView.deserializeBinary
);


/**
 * @param {!proto.dowtex.tournaments.ShareTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dowtex.tournaments.TournamentView)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dowtex.tournaments.TournamentView>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dowtex.tournaments.TournamentsClient.prototype.setShareToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/SetShareToken',
      request,
      metadata || {},
      methodDescriptor_Tournaments_SetShareToken,
      callback);
};


/**
 * @param {!proto.dowtex.tournaments.ShareTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dowtex.tournaments.TournamentView>}
 *     Promise that resolves to the response
 */
proto.dowtex.tournaments.TournamentsPromiseClient.prototype.setShareToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/SetShareToken',
      request,
      metadata || {},
      methodDescriptor_Tournaments_SetShareToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dowtex.tournaments.JoinRequest,
 *   !proto.dowtex.tournaments.TournamentView>}
 */
const methodDescriptor_Tournaments_Join = new grpc.web.MethodDescriptor(
  '/dowtex.tournaments.Tournaments/Join',
  grpc.web.MethodType.UNARY,
  proto.dowtex.tournaments.JoinRequest,
  proto.dowtex.tournaments.TournamentView,
  /**
   * @param {!proto.dowtex.tournaments.JoinRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dowtex.tournaments.TournamentView.deserializeBinary
);


/**
 * @param {!proto.dowtex.tournaments.JoinRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dowtex.tournaments.TournamentView)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dowtex.tournaments.TournamentView>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dowtex.tournaments.TournamentsClient.prototype.join =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/Join',
      request,
      metadata || {},
      methodDescriptor_Tournaments_Join,
      callback);
};


/**
 * @param {!proto.dowtex.tournaments.JoinRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dowtex.tournaments.TournamentView>}
 *     Promise that resolves to the response
 */
proto.dowtex.tournaments.TournamentsPromiseClient.prototype.join =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dowtex.tournaments.Tournaments/Join',
      request,
      metadata || {},
      methodDescriptor_Tournaments_Join);
};


module.exports = proto.dowtex.tournaments;

